export default "__VITE_ASSET__DP0aSLN6__"